import { createContext, useContext } from "react";
import type { createStreamChatJob } from "@planzone/services";

type ChatStream = ReturnType<typeof createStreamChatJob>;

const ChatStreamContext = createContext<ChatStream>(() =>
  Promise.reject(new Error("ChatStreamContext not provided")),
);

function useChatStreamContext(): ChatStream {
  return useContext(ChatStreamContext);
}

export { ChatStreamContext, useChatStreamContext };
